import { AXIS_Y } from './geometry';

interface TimelineAxisProps {
    width: number;
    selectedX: number | null;
}

function TimelineAxis({ width, selectedX }: TimelineAxisProps) {
    return (
        <div className="absolute inset-0" aria-hidden>
            <div
                className="absolute bg-gray-300"
                style={{ top: AXIS_Y, left: 0, width, height: 1 }}
            />
            {selectedX != null && (
                <div
                    className="absolute bg-gray-900"
                    style={{ top: 0, left: selectedX, width: 1, height: AXIS_Y }}
                />
            )}
        </div>
    );
}

export { TimelineAxis };
